module.exports = __webpack_public_path__ + "img/FountainOfLife.5c769eb7.jpg";